import { invert } from 'lodash';
var TO_CORVID_ENTITY_RENAMED_KEYS = {
    id: '_id',
    createdDate: '_createdDate',
    updatedDate: '_updatedDate',
};
var FROM_CORVID_ENTITY_RENAMED_KEYS = invert(TO_CORVID_ENTITY_RENAMED_KEYS);
var isReservedCorvidFieldName = function (name) {
    return name in FROM_CORVID_ENTITY_RENAMED_KEYS;
};
var isReservedCommonFieldName = function (name) {
    return name in TO_CORVID_ENTITY_RENAMED_KEYS;
};
var toCorvidName = function (name) { return TO_CORVID_ENTITY_RENAMED_KEYS[name] || name; };
var fromCorvidName = function (name) { return FROM_CORVID_ENTITY_RENAMED_KEYS[name] || name; };
export { TO_CORVID_ENTITY_RENAMED_KEYS, FROM_CORVID_ENTITY_RENAMED_KEYS, toCorvidName, fromCorvidName, isReservedCorvidFieldName, isReservedCommonFieldName, };
//# sourceMappingURL=index.js.map